import React, { FC, useContext } from 'react'
import { JournalSectionContext } from '../../../contexts/journalSectionProvider'
import Title from '../../common/Title/Title'
import MaxWidth from '../../layout/MaxWidth/MaxWidth'
import JournalFeed from '../JournalFeed/JournalFeed'
import TopBar from '../TopBar/TopBar'
import css from '../JournalMain/JournalMain.module.scss'
import Loader from '../../common/Loader/Loader'
import { ButtonTheme } from '../../types'
import Button from '../../common/Button/Button'

const JournalSection: FC = () => {
  const { sections, items, sectionName, hasNextPage, loading, loadMore } =
    useContext(JournalSectionContext)

  return (
    <div>
      <TopBar sections={sections} />

      <MaxWidth mobileWide>
        <Title big={true} className={css.heading}>
          {sectionName}
        </Title>
      </MaxWidth>

      <MaxWidth mobileWide>
        <JournalFeed feed={items} />
      </MaxWidth>

      {hasNextPage && (
        <div className={css.loadMore}>
          {loading ? (
            <Loader />
          ) : (
            <Button theme={ButtonTheme.ellipseBig} onClick={loadMore}>
              Еще статьи
            </Button>
          )}
        </div>
      )}
    </div>
  )
}

export default JournalSection
